// @flow
import tw from 'tailwind-styled-components'

const Breadcrumbs = tw.div`
  sm:px-6
  mt-6
 `

export default Breadcrumbs
